import { Select as SelectComponent } from "./Select";

export const Select = Object.assign(SelectComponent, {})